import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { getAuthenticityToken } from '../shared/helpers'

const setFieldValue = (selector, value) => {
  const el = document.querySelector(selector)
  if (!el) { return }
  el.value = value
  el.dispatchEvent(new Event('change', { bubbles: true }))
}

const CourseLocation = (props) => {
  useEffect(() => {
    const mapboxEl = document.querySelector('mapbox-address-autofill')
    if (!mapboxEl) { return }

    const mapboxInput = mapboxEl.querySelector('input[autocomplete="address-line1"]')
    const formField = document.querySelector('input[name="course[address_street]"]')

    if (mapboxInput && formField?.value) {
      mapboxInput.value = formField.value
    }

    if (mapboxInput) {
      mapboxInput.addEventListener('input', (e) => {
        setFieldValue('input[name="course[address_street]"]', e.target.value)
      })
    }

    const handleRetrieve = async (event) => {
      const feature = event.detail?.features?.[0]
      const addressText = mapboxInput.value
      if (!addressText) { return }

      const buildAddress = feature?.properties?.full_address || addressText
      const res = await fetch(`${props.loadAddressUrl}?address=${encodeURIComponent(buildAddress)}`, {
        method: 'GET',
        headers: {'X-CSRF-Token': getAuthenticityToken()},
      })
      const data = await res.json()

      if (res.status !== 200) {
        window.show_flash(!window.I18n ? '' : window.I18n.t('views.golfhub.errors.bad_course_load'))
        setFieldValue('input[name="course[address_street]"]', addressText)
        mapboxInput.value = addressText
      } else {
        setFieldValue('input[name="course[address_street]"]', data.address_street || '')
        setFieldValue('input[name="course[address_zip]"]', data.zip || '')
        setFieldValue('input[name="course[city]"]', data.city || '')
        setFieldValue('select[name="course[country]"]', data.country || '')
        setFieldValue('input[name="course[latitude]"]', data.latitude || '')
        setFieldValue('input[name="course[longitude]"]', data.longitude || '')

        setTimeout(() => {
          const stateSelect = document.querySelector('select[name="course[state]"]')
          if (!stateSelect) { return }

          const stateCode = [ ...stateSelect.options ].find(
            opt => opt.text === data.state || opt.value === data.state,
          )?.value
  
          if (stateCode) {
            setFieldValue('select[name="course[state]"]', stateCode)
          }
        }, 1500)
      }
    }

    mapboxEl.addEventListener('retrieve', handleRetrieve)
    return () => mapboxEl.removeEventListener('retrieve', handleRetrieve)
  }, [])

  return null
}

CourseLocation.propTypes = {
  leagueId: PropTypes.string.isRequired,
  loadAddressUrl: PropTypes.string.isRequired,
}

export default CourseLocation
